<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <p>{{ labantibiotics }}</p> -->
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filters" class="dataTables_filter text-md-end">
                  <b-button
                    v-if="user_permissions.add_organism"
                    variant="primary"
                    v-b-modal.organism-modal
                    ><i class="fa fa-plus"></i> New organism</b-button
                  >
                  <button
                    v-else
                    class="btn btn-outline-primary btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> New organism
                  </button>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_long" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                bordered
                class="datatables"
                :items="laborganisms"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(action)="data">
                  <!-- Edit Modal -->
                  <b-button
                    v-if="user_permissions.edit_organism"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-organism-modal
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <button
                    v-else
                    class="btn btn-outline-primary btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> Edit
                  </button>
                  |
                  <!-- Delete Modal -->
                  <b-button
                    v-if="user_permissions.delete_organism"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-organism-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash-alt"></i> Delete</b-button
                  >
                  <button
                    v-else
                    class="btn btn-outline-danger btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> Delete
                  </button>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!laborganisms" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add organism model -->
    <b-modal
      hide-footer
      id="organism-modal"
      :title="'ADD NEW ORGANISM'"
      title-class="font-18"
      @hidden="clearInput(), resetError()"
    >
      <div class="form-group">
        <label class="col-form-label">Organism Name</label>

        <input
          v-model="data.name"
          type="text"
          class="form-control"
          placeholder="Organism Name"
          @input="resetErrors()"
        />
      </div>
      <div class="text-danger" v-if="nameError">
        <em>{{ nameError }}</em>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary float-start"
          @click="closeModal('organism-modal')"
        >
          Cancel
        </button>
        <button @click="addOrgan('organism-modal')" type="submit" class="btn btn-success">
          Submit <i class="fa fa-check"></i>
        </button>
        <b-spinner
          v-if="PickingStatus"
          class="m-0"
          variant="primary"
          role="status"
        ></b-spinner>
      </div>
    </b-modal>
    <!-- edit modal starts -->
    <b-modal id="edit-organism-modal" hide-footer @hidden="resetEditOrganism">
      <template #modal-title> Edit Organism {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Organism Name</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            @input="resetError()"
            v-model="editdata.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-organism-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editOrganism('edit-organism-modal')"
        >
          <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="PickingStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete Organism starts -->
    <b-modal id="delete-organism-modal" hide-footer @hidden="resetDeleteOrganism">
      <template #modal-title>
        <h4 class="text-danger">Delete Organism {{ deletedata.name }}</h4></template
      >
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to delete this Organism? Click Proceed Button to delete.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-organism-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteOrganism('delete-organism-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="PickingStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
  page: {
    title: "Laboratory Organisms",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "Laboratory Organisms",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Laboratory Organisms",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "organism",
          sortable: true,
          label: "NAME",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE & TIME",
        },
        // {
        //   key: "action",
        //   sortable: false,
        //   label: "ACTION",
        // },
      ],
      data: {
        name: "",
      },
      // edit position
      editdata: {
        name: "",
        id: "",
      },
      // delete position
      deletedata: {
        name: "",
        id: "",
      },
      modal_id: "",
      nameError: "",
    };
  },

  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("laboratory", ["laborganisms", "PickingStatus"]),
    ...mapGetters("auth", ["user_permissions"]),

    rows() {
      return this.laborganisms ? this.laborganisms.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.laborganisms ? this.laborganisms.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchOrganism: "laboratory/fetchLabOrganisms",
      AddOrganism: "laboratory/addOrganisms",
      EditOrganism: "laboratory/editOrganism",
      DeleteOrganism: "laboratory/deleteOrganism",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    addOrgan(modalId) {
      if (this.data.name == "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError == "";
      }
      this.modal_id = modalId;
      this.AddOrganism(this.data);
    },
    clearInput() {
      this.data.name = "";
    },
    resetError() {
      this.nameError = "";
    },
    resetEditOrganism() {
      this.editdata.name = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeleteOrganism() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.organism;
      this.editdata.id = data.item.id;
    },
    editOrganism(modalId) {
      this.modal_id = modalId;
      this.EditOrganism(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.organism;
      this.deletedata.id = data.item.id;
    },
    deleteOrganism(modalId) {
      this.modal_id = modalId;
      this.DeleteOrganism(this.deletedata);
    },

    // CLOSE MODEL
    closeModal(model_id) {
      this.clearInput();
      this.resetError();
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
    // END CLOSE MODEL
  },

  created() {
    this.FetchOrganism();
  },
};
</script>

<style lang="css" scoped></style>
